import { CdnApiClient } from "../../clients/cdn-client";
import { HeroShared } from "./models/shared";

export class SharedRepository {
    private _client: CdnApiClient;

    constructor() {
        this._client = new CdnApiClient('/shared');
    }

    async getHero(heroName: string, lang: Language): Promise<HeroShared> {
        const route = `${lang}_${heroName}.json`

        return await this._client.getSimple<HeroShared>(route);
    }
}